import {
  createTheme,
  Tab as MuiTab,
  Tabs as MuiTabs,
  ThemeProvider,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import TabProps from './types';

const theme = createTheme({
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 'unset',
          overflow: 'unset',
        },
        indicator: {
          height: '0.8vw',
          backgroundColor: '#1F2D49',
          '@media (orientation: landscape)': {
            height: '0.4vw',
          },
        },
        flexContainer: {
          justifyContent: 'space-between',
        },
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          minHeight: 'unset',
          minWidth: 'unset',
          height: '7.8vw',
          padding: '1.2vw',
          fontSize: '3.6vw',
          fontWeight: 'normal',
          '&.Mui-selected': {
            color: '#1F2D49',
            fontWeight: 600,
          },
          marginBottom: '0.5vw',
          '@media (orientation: landscape)': {
            fontSize: '1.8vw',
          },
        },
        textColorPrimary: {
          color: '#8B8B8B',
        },
      },
    },
  },
});

const Tab: React.FC<TabProps> = ({
  options,
  value,
  onChange,
  customStyle,
  customProps,
}) => {
  const [index, setIndex] = useState(value ?? 0);

  useEffect(() => {
    onChange(index);
  }, [index, onChange]);

  return (
    <ThemeProvider theme={theme}>
      <MuiTabs
        variant="fullWidth"
        value={value ?? index}
        onChange={(_, value) => setIndex(value)}
        sx={{
          '.MuiTab-root': {
            '@media (orientation: landscape)': {
              height: '3.9vw',
            },
          },
          ...customStyle,
        }}
        {...customProps}
      >
        {options.map((option) => {
          return <MuiTab key={option} label={option} />;
        })}
      </MuiTabs>
    </ThemeProvider>
  );
};

export default Tab;
